export enum VerificationRequestGroup {
  verificationOfEmployment = 'Verification of Employment',
  verificationOfIncome = 'Verification of Income',
  reverification = 'Reverification',
}

export enum DashboardClearVerifyRevenueDimensions {
  month = 'month',
  chargeAmount = 'chargeAmount',
  type = 'type',
}
